module.exports = __webpack_public_path__ + "img/ozo_logo-mobile.9850735f.svg";